import { Component } from '@angular/core';
import { HasScopeDirective } from '../../../../../services/scope/has-scope.directive';
import { SCOPES } from '../../../../../services/scope/scope-constants';
import { OffersListComponent } from '../../../../../components/admin-dashboard-component/promotions/offers-management/offers-list-component/offers-list-component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-offers-list-page',
  imports: [RouterLink, HasScopeDirective, OffersListComponent],
  templateUrl: './offers-list-page.html',
  styleUrl: './offers-list-page.scss',
})
export class OffersListPage {
  readonly SCOPES = SCOPES;
}
